// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getUserStripeCustomerId = async ({
    test,
}: {
    test: boolean,
}): Promise<string | undefined> => {
    const functions = getFunctions();
    const handleGetUserStripeCustomerId = httpsCallable<
        Record<
            string,
            boolean
        >,
        string | undefined
    >(
        functions,
        'getUserStripeCustomerId',
    );
    return handleGetUserStripeCustomerId({
        test,
    }).then((result) => {
        const stripeCustomerId = result.data as string | undefined;
        return stripeCustomerId;
    }).catch((err) => {
        throw err;
    });
};

export default getUserStripeCustomerId;
